import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const CTASection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ backgroundColor: '#212121', color: 'white', py: 10 }}>
      <Container maxWidth="lg">
        <Box textAlign="center">
          <Typography
            variant="h3"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: 700,
              mb: 3
            }}
          >
            {t('cta.readyToTransform')}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 6,
              opacity: 0.9,
              maxWidth: 600,
              mx: 'auto'
            }}
          >
            {t('cta.joinThousandsProfessionals')}
          </Typography>
          
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/auth?mode=signup')}
              sx={{
                backgroundColor: '#f5f5dc',
                color: 'black',
                fontWeight: 'bold',
                fontSize: '1.2rem',
                px: 5,
                py: 2.5,
                borderRadius: 3,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#e8e8c8',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              {t('cta.startFree')}
            </Button>
            <Typography variant="body1" sx={{ opacity: 0.8 }}>
              {t('cta.freeTrialNoCard')}
            </Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;